/**
 * CRM 主业务接口汇总文件
 * 功能：覆盖基础配置（国家/客户账号/标签/模板）、eBay 邮件与退款、Amazon 邮件/退款/中差评、Ozon 邮件与客服等模块的接口封装
 */
import request from "../utils/request"
import config from '@/config/config'
const rootApi = config.serverPath.server;
var qs = require('qs');
/** 通用导出接口，支持 get/post 并以 blob 形式下载文件 */
export const exportExcel = (para, url, type) => {
    if (type === 'post') {
        return request.post(rootApi + url,
            para, {
            responseType: 'blob'
        });

    } else {
        return request.get(rootApi + url, {
            params: para,
            responseType: 'blob'
        });
    }
};
/** 查询国家列表 */
export const getCountryList = (para) => {
    return request.get(rootApi + "/base/country/list", {
        params: para
    });
};
/** 新增国家 */
export const countryAdd = (para) => {
    return request.post(rootApi + "/base/country/add", para);
};
/** 查询客户账号列表 */
export const getCustomerAccountList = (para) => {
    return request.get(rootApi + "/config/customerAccount/list", {
        params: para
    });
};
/** 查询操作日志 */
export const getLog = (para) => {
    return request.get(rootApi + "/common/log/list", {
        params: para
    });
};
/** 新增客户账号 */
export const customerAccountAdd = (para) => {
    return request.post(rootApi + "/config/customerAccount/add", para);
};
/** 获取下拉数据 */
export const dropDownList = (para) => {
    return request.post(rootApi + "/common/dropDownList", para);
};
/** 编辑客户账号 */
export const customerAccountEdit = (para) => {
    return request.post(rootApi + "/config/customerAccount/edit", para);
};
/** 删除客户账号 */
export const customerAccountDelete = (para) => {
    return request.get(rootApi + "/config/customerAccount/delete", {
        params: para
    });
};
/** 查询标签配置列表 */
export const getLabelConfigList = (para) => {
    return request.get(rootApi + "/config/labelConfig/list", {
        params: para
    });
};
/** 新增标签配置 */
export const labelConfigAdd = (para) => {
    return request.post(rootApi + "/config/labelConfig/add", para);
};
/** 编辑标签配置 */
export const labelConfigEdit = (para) => {
    return request.post(rootApi + "/config/labelConfig/edit", para);
};
/** 删除标签配置 */
export const labelConfigDelete = (para) => {
    return request.get(rootApi + "/config/labelConfig/delete", {
        params: para
    });
};
/** 查询邮件模板列表 */
export const getTemplateList = (para) => {
    return request.get(rootApi + "/config/template/list", {
        params: para
    });
};
/** 新增邮件模板 */
export const templateAdd = (para) => {
    return request.post(rootApi + "/config/template/add", para);
};
/** 编辑邮件模板 */
export const templateEdit = (para) => {
    return request.post(rootApi + "/config/template/edit", para);
};
/** 删除邮件模板 */
export const templateDelete = (para) => {
    return request.get(rootApi + "/config/template/delete", {
        params: para
    });
};
/** 查询 eBay 账号列表 */
export const ebayAccountList = (para) => {
    return request.get(rootApi + "/account/ebayAccount/list", {
        params: para
    });
};
/** 查询 eBay 邮件列表 */
export const getMessageList = (para) => {
    return request.get(rootApi + "/ebay/ebayMessage/getMessageList", {
        params: para
    });
};
/** 标记邮件已回复 */
export const markMessageReply = (para) => {
    return request.post(rootApi + "/ebay/ebayMessage/markMessageReply", para);
};
/** 标记邮件已读 */
export const markMessageRead = (para) => {
    return request.post(rootApi + "/ebay/ebayMessage/markMessageRead", para);
};
/** 查询 eBay 草稿列表 */
export const ebayMessageDraft = (para) => {
    return request.get(rootApi + "/ebay/ebayMessageDraft/list", {
        params: para
    });
};
/** 查询已发送邮件列表 */
export const ebayMessageSentList = (para) => {
    return request.get(rootApi + "/ebay/ebayMessageSent/list", {
        params: para
    });
};
/** 查询订单备注列表 */
export const orderRemarkList = (para) => {
    return request.get(rootApi + "/ebay/orderRemark/list", {
        params: para
    });
};
/** 获取邮件回复信息 */
export const replyMessageInfo = (para) => {
    return request.get(rootApi + "/ebay/ebayMessage/replyMessage", {
        params: para
    });
};
/** 新增订单备注 */
export const addorderRemark = (para) => {
    return request.post(rootApi + "/ebay/orderRemark/add", para);
};
/** 编辑订单备注 */
export const editorderRemark = (para) => {
    return request.post(rootApi + "/ebay/orderRemark/edit", para);
};
/** 删除订单备注 */
export const orderRemarkDelete = (para) => {
    return request.get(rootApi + "/ebay/orderRemark/delete", {
        params: para
    });
};
/** 查询产品资料 */
export const getProductList = (para) => {
    return request.get(rootApi + "/config/product/getProduct", {
        params: para
    });
};
/** 保存草稿 */
export const ebayMessageDraftSave = (para) => {
    return request.post(rootApi + "/ebay/ebayMessageDraft/save", para);
};
/** 导入 Excel 文件 */
export const imporstExcel = (para, url) => {
    return request.post(rootApi + url, para);
}
/** 发送 eBay 邮件 */
export const sendMessage = (para) => {
    return request.post(rootApi + "/ebay/ebayMessage/sendMessage", para);
};
/** 更换客服 */
export const changeCustomer = (para) => {
    return request.post(rootApi + "/ebay/ebayMessage/changeCustomer", para);
};
/** 批量发送草稿 */
export const sendBatch = (para) => {
    return request.post(rootApi + "/ebay/ebayMessageDraft/sendBatch", para);
};
/** 同步 eBay 账号 */
export const ebayAccountSync = (para) => {
    return request.get(rootApi + "/account/ebayAccount/sync", {
        params: para
    });
};
/** 获取 eBay 邮件详情 */
export const getEbayMessage = (para) => {
    return request.get(rootApi + "/ebay/ebayMessage/getEbayMessage", {
        params: para
    });
};
/** 删除上传的图片 */
export const delImg = (para) => {
    return request.get(rootApi + "/common/upload/deleteImg", {
        params: para
    });
};

/** 查询 Amazon 账号列表 */
export const amazonAccountList = (para) => {
    return request.get(rootApi + "/amazon/account/list", {
        params: para
    });
};
/** 同步 Amazon 账号 */
export const amazonAccountSync = (para) => {
    return request.get(rootApi + "/amazon/account/syncAmazonAccount", {
        params: para
    });
};
// 国家语种
export const getLanguage = (para) => {
    return request.post(rootApi + "/common/translation/list", para);
};
// 翻译
export const translate = (para) => {
    // return request.post(rootApi + "/common/translation", para);
    return request.post(rootApi + "/common/translation",
        qs.stringify(para), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
};

// eBay标记邮件未回复 重要邮件 待办邮件 垃圾邮件
export const editStatus = (para) => {
    return request.post(rootApi + "/ebay/ebayMessage/updateMessageStatus", para);
};
// 以下亚马逊邮件相关接口
// 邮件详情
export const amazonEmailDetail = (para) => {
    // return request.get(rootApi + "/amazon/message/detailById", {
    //     params: para
    // });
    return request.get(rootApi + "/amazon/message/getMessageDetail", {
        params: para
    });
};
/** 查询 Amazon 邮件列表 */
export const amazonEmailList = (para) => {
    return request.get(rootApi + "/amazon/message/getMessageList", {
        params: para
    });
};
/** 查询 Amazon 草稿列表 */
export const amazonDraftsList = (para) => {
    return request.get(rootApi + "/Amazon/AmazonMessageSend/Draftslist", {
        params: para
    });
};
/** 查询 Amazon 已发送邮件列表 */
export const amazonSendList = (para) => {
    return request.get(rootApi + "/Amazon/AmazonMessageSend/list", {
        params: para
    });
};
// export const singImportant = (para) => {
//     return request.post(rootApi + "/amazon/message/updateImportantStatus", para);
// };
// 标记已读未读
export const singRed = (para) => {
    return request.post(rootApi + "/amazon/message/updateReadStatus", para);
};
// 获取模板
export const getTemplate = (para) => {
    return request.get(rootApi + "/Amazon/AmazonMessageSend/getTemplateContent", {
        params: para
    });
};
// 发送邮件
export const amazonSendEmail = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/sendMessage", para);
};
// 存草稿箱
export const saveDrafts = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/sendDrafts", para);
};
// 回复
export const replyEmail = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/replyMessages", para);
};
// Outlook Graph 回复
export const outlookReplyEmail = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/outlookReplyMessages", para);
};
// 重发
export const resendEmail = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/ResendMessage", para);
};
// 草稿箱发送
export const resendDraftsEmail = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/DraftsMessage", para);
};
// 修改收件箱是否重要邮件状态
export const editSentImport = (para) => {
    return request.get(rootApi + "/Amazon/AmazonMessageSend/updateImport", {
        params: para
    });
};
// 统计收件箱已回复总数和未回复
export const getEmailCount = (para) => {
    return request.get(rootApi + "/amazon/message/getReplyCount", {
        params: para
    });
};
// 新增标签
export const addLabelsing = (para) => {
    return request.post(rootApi + "/userLabelMessageConfig/add", para);
};
// 编辑标签
export const editaddLabelsing = (para) => {
    return request.post(rootApi + "/userLabelMessageConfig/update ", para);
};
// 标记邮件未回复 重要邮件 待办邮件 垃圾邮件
export const updateStatus = (para) => {
    return request.post(rootApi + "/amazon/message/UpdateStatus ", para);
};
/** 查询 Amazon 客服账号绑定列表 */
export const getAmazonList = (para) => {
    return request.get(rootApi + "/amazonEmailUserConfig/list", {
        params: para
    });
};
/** 删除 Amazon 客服绑定 */
export const delAmazon = (para) => {
    return request.get(rootApi + "/amazonEmailUserConfig/delete", {
        params: para
    });
};
/** 新增 Amazon 客服绑定 */
export const addAmazonUser = (para) => {
    return request.post(rootApi + "/amazonEmailUserConfig/add", para);
};
/** 编辑 Amazon 客服绑定 */
export const editAmazonUser = (para) => {
    return request.post(rootApi + "/amazonEmailUserConfig/edit", para);
};
/** 查询账号关联的邮件列表 */
export const getAmazonEmailList = (para) => {
    return request.get(rootApi + "/amazonEmailUserConfig/emailList", {
        params: para
    });
};
/** 发送 eBay 邮件（已发送列表场景） */
export const ebaySendEmail = (para) => {
    return request.post(rootApi + "/ebay/ebayMessageSent/sendMessage", para);
};
/** 更换 Amazon 邮件客服 */
export const editAmazonCustomer = (para) => {
    return request.post(rootApi + "/amazon/message/changeCustomer", para);
};
/** 同步 Amazon 邮件 */
export const syncAmazonMessage = (para) => {
    return request.get(rootApi + "/amazon/message/syncAmazonMessage", {
        params: para
    });
};
// 重新生成AI回复
export const requestAmazonDify = (para) => {
    return request.post(rootApi + "/amazon/message/requestAmazonDify", para);
};
/** 同步邮件类型 */
export const syncMailType = (para) => {
    return request.get(rootApi + "/amazon/message/syncMailType", {
        params: para
    });
};
/** 查询邮件关联订单 */
export const getAmazonMessageOrder = (para) => {
    return request.get(rootApi + "/amazon/message/getMessageOrder", {
        params: para
    });
};

// 亚马逊订单号校验
export const judgeOrderNo = (para) => {
    return request.get(rootApi + "/Amazon/AmazonMessageSend/getOrderAccount", {
        params: para
    });
};
/** 新增并保存 eBay 草稿 */
export const ebaySaveDraft = (para) => {
    return request.post(rootApi + "/ebay/ebayMessageDraft/saveAddDraft", para);
};
/** 批量发送 Amazon 邮件 */
export const amazonBatchSend = (para) => {
    return request.post(rootApi + "/Amazon/AmazonMessageSend/sendBatch", para);
};
// eBay订单校验
export const judgeEBayOrderNo = (para) => {
    return request.get(rootApi + "/ebay/ebayMessageSent/getOrderAccount", {
        params: para
    });
};
/** 按发件人查询 Amazon 邮件 */
export const getAmazonMailTitle = (para) => {
    return request.get(rootApi + "/amazon/message/getAmazonMessageBySender", {
        params: para
    });
};
/** 按 ID 查询 Amazon 邮件 */
export const getAmazonMessageById = (para) => {
    return request.get(rootApi + "/amazon/message/getAmazonMessageById", {
        params: para
    });
};

// 售后管理相关接口
export const getFeeBackList = (para) => {
    return request.get(rootApi + "/Amazon/FeeBack/getFeeBackList", {
        params: para
    });
};
/** 新增售后备注 */
export const addRemark = (para) => {
    return request.post(rootApi + "/Amazon/FeeBack/addFeeBackRemark", para);
};
/** 查询 Amazon 订单详情 */
export const getAmazonOrderInfo = (para) => {
    return request.get(rootApi + "/Amazon/FeeBack/getFeeBackOrderDetail", {
        params: para
    });
};
/** 查询退款记录列表 */
export const getAmazonRefundInfo = (para) => {
    return request.get(rootApi + "/Amazon/RefundRecordDetail/getRefundRecordList", {
        params: para
    });
};
// 退款原因
export const getBaseRefundReason = (para) => {
    return request.get(rootApi + "/Amazon/Refund/getBaseRefundReason", {
        params: para
    });
};
/** 按 SKU 查询退款订单详情 */
export const getSkuInfoById = (para) => {
    return request.get(rootApi + "/Amazon/Refund/getRefundOrderDetail", {
        params: para
    });
};
/** 提交 Amazon 退款申请 */
export const amazonApplyRefund = (para) => {
    return request.post(rootApi + "/Amazon/Refund/save", para);
};
// 亚马逊作废
export const amazonVoidOrder = (para) => {
    return request.post(rootApi + "/Amazon/Refund/invalidRefundOrder", para);
};
/** 查询 Amazon 退款单列表 */
export const getAmazonRefundList = (para) => {
    return request.post(rootApi + "/Amazon/Refund/getRefundList", para);
};
/** 审核 Amazon 退款单 */
export const auditAmazonRefundOrder = (para) => {
    return request.post(rootApi + "/Amazon/Refund/auditRefundOrder", para);
};
/** 重推 Amazon 退款单 */
export const repushAmazonRefundOrder = (para) => {
    return request.post(rootApi + "/Amazon/Refund/pushAgainRefundOrder", para);
};

// ebay退款相关接口
export const getEbayRefundList = (para) => {
    return request.post(rootApi + "/crm/yy-ebay-refund/getRefundList", para);
};
// 审核
export const auditEbayRefund = (para) => {
    return request.post(rootApi + "/crm/yy-ebay-refund/auditRefundOrder", para);
};
// 作废
export const ebayVoidOrder = (para) => {
    return request.post(rootApi + "/crm/yy-ebay-refund/invalidRefundOrder", para);
};
// 重推ebay
export const repushEbayOrder = (para) => {
    return request.post(rootApi + "/crm/yy-ebay-refund/pushAgainRefundOrder", para);
};
// ebay、Amazon退款单日志
export const getRefundLog = (para) => {
    return request.post(rootApi + "/crm/yy-ebay-refund/findRefundTravel", para);
};
// ebay中差评
export const geteBayFeeBackList = (para) => {
    return request.post(rootApi + "/crm/yyEbayComment/getFeeBackList", para);
};
/** 查询 eBay 中差评订单详情 */
export const getFeeBackOrderDetail = (para) => {
    return request.get(rootApi + "/crm/yyEbayComment/getFeeBackOrderDetail", {
        params: para
    });
};
/** 新增 eBay 差评备注 */
export const addEbayRemark = (para) => {
    return request.post(rootApi + "/crm/yyEbayComment/addFeeBackRemark", para);
};
// ebay邮件详情订单信息
export const getEbayOrderInfo = (para) => {
    return request.get(rootApi + "/ebay/ebayMessage/replyOrder", {
        params: para
    });
};
/** 按邮箱同步 Amazon 邮件 */
export const AmazonSyncEmail = (para) => {
    return request.get(rootApi + "/amazon/message/syncByEmail", {
        params: para
    });
};
// 维护差评原因
export const updateAmazonLameReason = (para) => {
    return request.post(rootApi + "/Amazon/FeeBack/updateLameReason", para);
};
/** 维护 eBay 差评原因 */
export const updateEbayLameReason = (para) => {
    return request.post(rootApi + "/crm/yyEbayComment/updateLameReason", para);
};
/** 批量导入 Amazon 退款数据 */
export const uploadAmazonRefund = (para) => {
    return request.post(rootApi + "/Amazon/Refund/import", para);
};
/** 导出受限制的邮件（拦截导出） */
export const exportForbid = (para) => {
    return request.post(rootApi + "/amazon/message/exportForbid", para);
};
// 无需回复规则配置
export const getReplyRuleConfigList = (para) => {
    return request.get(rootApi + "/amazon/reply/ruleConfig/getReplyRuleConfigList", {
        params: para
    });
};
/** 删除回复规则 */
export const deleteRuleConfig = (para) => {
    return request.get(rootApi + "/amazon/reply/ruleConfig/deleteRuleConfig", {
        params: para
    });
};
/** 新增回复规则 */
export const addRuleConfig = (para) => {
    return request.post(rootApi + "/amazon/reply/ruleConfig/addRuleConfig", para);
};
// Ozon客服管理
export const getOzonCustomerList = (para) => {
    return request.post(rootApi + "/ozon/receptionistManager/getList", para);
};
/** 新增 Ozon 客服 */
export const addOzonCustomer = (para) => {
    return request.post(rootApi + "/ozon/receptionistManager/add", para);
};
/** 获取可绑定 Ozon 客服的新账号下拉列表 */
export const getNewAccountDropList = () => {
    return request.get(rootApi + "/ozon/receptionistManager/getNewAccountDropList");
};
/** 编辑 Ozon 客服 */
export const editOzonCustomer = (para) => {
    return request.post(rootApi + "/ozon/receptionistManager/edit", para);
};
/** 删除 Ozon 客服 */
export const delOzonCustomer = (para) => {
    return request.get(rootApi + "/ozon/receptionistManager/delete", {
        params: para
    });
};
// Outlook邮箱授权
/** 查询 Outlook 邮箱授权列表（分页） */
export const getOutlookAccountList = (para) => {
    return request.post(rootApi + "/Amazon/OutlookAccount/getPageList", para);
};
/** 新增 Outlook 邮箱授权账号 */
export const addOutlookAccount = (para) => {
    return request.post(rootApi + "/Amazon/OutlookAccount/add", para);
};
/** 获取 Outlook 邮箱授权链接 */
export const getOutlookAuthUrl = (para) => {
    return request.post(rootApi + "/Amazon/OutlookAccount/getAuthUrl", para);
};
// Ozon邮件列表
export const getOzonMessageList = (para) => {
    return request.post(rootApi + "/ozon/message/getList", para);
};
/** 批量标记 Ozon 邮件已回复 */
export const setReplyBatch = (para) => {
    return request.post(rootApi + "/ozon/message/setReplyBatch", para);
};
/** 标记 Ozon 邮件已读 */
export const setRead = (para) => {
    return request.get(rootApi + "/ozon/message/setRead", {
        params: para
    });
};
/** 标记 Ozon 邮件重要 */
export const markImportant = (para) => {
    return request.get(rootApi + "/ozon/message/markImportant", {
        params: para
    });
};
/** 查询 Ozon 邮件详情 */
export const ozonShowDetail = (para) => {
    return request.get(rootApi + "/ozon/message/showDetail", {
        params: para
    });
};
/** 发送 Ozon 邮件 */
export const ozonSendMessage = (para) => {
    return request.post(rootApi + "/ozon/message/sendMessage", para);
};
/** 发送 Ozon 附件 */
export const ozonSendFile = (para) => {
    return request.post(rootApi + "/ozon/message/sendFile", para);
};
/** 查询 Ozon 邮件关联订单信息 */
export const ozonGetOrderInfo = (para) => {
    return request.get(rootApi + "/ozon/message/getOrderInfo", {
        params: para
    });
};